import CommonModal from "./commonModal";

export default CommonModal;
